import React from 'react';

import Typography from '../../library/typography/typography';
import ExclamationCircleRegularIcon from '../../shared/icons/exclamation-circle-regular-icon';

import './package-includes-message.scss';

interface PackageIncludesMessageProps {
  isPrebuiltPackage?: boolean;
}

function PackageIncludesMessage(props: PackageIncludesMessageProps) {
  const { isPrebuiltPackage = false } = props;
  return (
    <div className="package-includes-message" styleName="container">
      <Typography variant="H6" weight="black">
        {' '}
        Wheel & Tire Package
      </Typography>
      {isPrebuiltPackage && (
        <div>
          <ExclamationCircleRegularIcon styleName="includes-icon" />{' '}
          <span styleName="includes-text">
            Package includes: 4 tires and 4 wheels
          </span>
        </div>
      )}
    </div>
  );
}

export default PackageIncludesMessage;
